module.exports = __webpack_public_path__ + "images/category_lp/earphone/assessment_achievements/5_ca0045db9dbee3a98e8b8b0a88a9e999.jpg";